// extracted by mini-css-extract-plugin
module.exports = {"dock":"StickyLaunchCta_dock__nlOJ0","btn":"StickyLaunchCta_btn__DcGc4"};